import defaultsDeep from 'lodash/defaultsDeep';
import { getGenericChartConfig } from 'JIX/highcharts/configs/generic_chart.js';

export function getStandardSplineChartConfig(options = {}) {
    const default_config = getGenericChartConfig({
        title: {
            text: "Spline Chart",
        },
        chart: {
            type: 'spline',
        },
        xAxis: {
            labels: {
                formatter: function () { return Math.floor(this.value); }
            }
        },
        yAxis: {
            min: 0,
        },
        plotOptions: {
            series: {
                shadow: {
                    opacity: 0.1,
                    width: 2,
                },
            }
        },
    });

    // Mutates 'options' with any 'default_config' options
    // that are missing from 'options'
    defaultsDeep(options, default_config);

    return options;
}

export function getDatetimeChartConfig(options = {}) {
    const default_config = getGenericChartConfig({
        title: {
            text: "Datetime Spline Chart",
        },
        chart: {
            type: 'spline',
        },
        xAxis: {
            type: 'datetime',
        },
        yAxis: {
            min: 0,
        },
        plotOptions: {
            series: {
                shadow: {
                    opacity: 0.1,
                    width: 2,
                },
            }
        },
        time: {
            timezone: "Europe/Copenhagen",
        },
    });

    // Mutates 'options' with any 'default_config' options
    // that are missing from 'options'
    defaultsDeep(options, default_config);

    return options;
}
